module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('global-nav'), _c('div', {
    staticClass: "container"
  }, [_c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1), _c('foot', [_c('b', [_c('a', {
    attrs: {
      "href": "https://projects.fivethirtyeight.com/trump-approval-ratings/",
      "target": "_blank"
    }
  }, [_vm._v("Trump Approval Ratings ")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75d7ffd9"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1083
// module chunks = 1